"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_1 = require("react-router");
var formApi_1 = require("../service/formApi");
var JourneyTypes_1 = require("../../../../common/enum/JourneyTypes");
var Routes_1 = require("../../common/enum/Routes");
var useAppContext_1 = require("../../common/react/useAppContext");
var enquiryFormDataTransformer_1 = require("../service/enquiryFormDataTransformer");
var useDealErrorHandler_1 = require("../../common/react/useDealErrorHandler");
var constants_1 = require("../../common/constants/constants");
var EnquiryFormSubmitErrorCodes_1 = require("../../common/enum/EnquiryFormSubmitErrorCodes");
var useEnquiryFormSubmit = function (handleAsyncValidationErrors, journeyType) {
    var location = react_router_1.useLocation();
    var history = react_router_1.useHistory();
    var _a = react_1.useState(null), error = _a[0], setError = _a[1];
    var _b = react_1.useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var _c = useAppContext_1.default(), setDeal = _c.setDeal, setUser = _c.setUser;
    var handleDealError = useDealErrorHandler_1.default();
    var onSubmit = react_1.useCallback(function (_a) {
        var formData = _a.formData;
        setIsSubmitting(true);
        window.grecaptcha.ready(function () {
            window.grecaptcha
                .execute(constants_1.default.RECAPTCHA_SITE_KEY, { action: 'submit' })
                .then(function (token) {
                formData.captchaToken = token;
                return formApi_1.default.setData(enquiryFormDataTransformer_1.default.from(formData), journeyType);
            })
                .then(function (deal) {
                var _a;
                var setJourneyCode = ((_a = deal) === null || _a === void 0 ? void 0 : _a.journeyType) === JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP ? formApi_1.default.createAppointment() : Promise.resolve();
                return setJourneyCode.then(function () {
                    var _a;
                    setDeal(deal);
                    // Customer is logged-in on this call
                    // TODO: When IDS PE will be implemented, take the info from customer entity.
                    setUser({
                        logged_in: true,
                        in_dealer: false,
                        user: deal.customer,
                    });
                    setIsSubmitting(false);
                    history.push(__assign(__assign({}, location), { pathname: "" + (((_a = deal) === null || _a === void 0 ? void 0 : _a.journeyType) === JourneyTypes_1.JourneyTypes.RESERVE_ONLINE ? Routes_1.Routes.PAYMENT : Routes_1.Routes.CONFIRMATION_REQUEST_QUOTE) }));
                });
            })
                .catch(function (error) {
                var _a, _b, _c;
                // Handle validation errors and prevent Themed Error to trigger
                if (((_c = (_b = (_a = error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.code) === EnquiryFormSubmitErrorCodes_1.default.VALIDATION_ERROR) {
                    handleAsyncValidationErrors(error);
                    setError(false);
                }
                else if (error === null) {
                    setError('NULL received as error on submit. This might be an issue with recaptcha domains.');
                }
                else {
                    error = handleDealError(error);
                    setError(error || null);
                }
                setIsSubmitting(false);
            });
        });
    }, []);
    return { isSubmitting: isSubmitting, onSubmit: onSubmit, error: error };
};
exports.default = useEnquiryFormSubmit;
